import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Panel } from "@/components/dash";
import { DataTable } from "@/components/DataTable";
import { inputCls, btnPrimary, btnGhost } from "@/components/admin/AdminLayout";

export default function AdminProducts() {
  const [f, setF] = useState({ name: "", category: "", product_code: "" });
  const { data = [], refetch } = useQuery({ queryKey: ["admin-products"], queryFn: async () => (await api.get("/admin/products")).data });
  const add = async () => { if (!f.name) return; await api.post("/admin/products", f); setF({ name: "", category: "", product_code: "" }); refetch(); toast.success("Product saved"); };
  const del = async (n) => { await api.delete(`/admin/products/${encodeURIComponent(n)}`); refetch(); };
  const imp = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    try { const r = (await api.post("/admin/products/import", fd)).data; toast.success(`${r.imported} products imported`); refetch(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="CMS · Products" title="Chemicals & Products" desc="Products are created automatically when dashboard data is uploaded. Add new ones here or import a list from Excel (Product ID, Product Name, Category) or Word." />
      <Panel title="Add / import">
        <div className="flex flex-wrap gap-3 items-center">
          <input className={inputCls} placeholder="Product name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="admin-product-name" />
          <input className={inputCls} placeholder="Family (e.g. Feedstock)" value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} data-testid="admin-product-category" />
          <input className={inputCls} placeholder="Product ID" value={f.product_code} onChange={(e) => setF({ ...f, product_code: e.target.value })} />
          <button className={btnPrimary} onClick={add} data-testid="admin-product-add">Add</button>
          <label className={`${btnGhost} flex items-center cursor-pointer ml-auto`}>Import Excel / Word<input type="file" accept=".xlsx,.docx" className="hidden" data-testid="admin-product-import" onChange={(e) => e.target.files[0] && imp(e.target.files[0])} /></label>
        </div>
      </Panel>
      <Panel title={`${data.length} products`}>
        <DataTable testId="admin-products-table" pageSize={20} rows={data} columns={[{ key: "name", label: "Product" }, { key: "product_code", label: "ID" }, { key: "category", label: "Family" },
          { key: "modules", label: "Dashboards with data", render: (r) => (r.modules || []).join(", ") },
          { key: "x", label: "", render: (r) => <button className={btnGhost} onClick={() => del(r.name)}>Remove</button> }]} />
      </Panel>
    </div>
  );
}
